import { useEffect } from 'react';

export type HardwareMicButtonPress = {
  deviceKey: string;
  buttonId: string;
  action?: { type: string; snippetId?: string };
};

export type HardwareMicButtonListenerPort = {
  enabled: boolean;
  isTauri: () => boolean;
  listen: (
    cb: (event: { payload: HardwareMicButtonPress }) => void
  ) => Promise<() => void>;
  onPress: (payload: HardwareMicButtonPress) => void;
};

/** Subscribe to hardware-mic presses. Tauri and the action handler are injected. */
export const useHardwareMicButtonListener = ({
  enabled,
  isTauri,
  listen,
  onPress,
}: HardwareMicButtonListenerPort): void => {
  useEffect(() => {
    if (!enabled || !isTauri()) return;

    let cancelled = false;
    let unlisten: (() => void) | undefined;

    void listen((event) => {
      onPress(event.payload);
    }).then((un) => {
      if (cancelled) {
        un();
        return;
      }
      unlisten = un;
    });

    return () => {
      cancelled = true;
      unlisten?.();
    };
  }, [enabled, isTauri, listen, onPress]);
};
